<script>
import FileListItem from './FileListItem'

export default {
  name: 'FileList',

  components: {
    FileListItem
  },

  props: {
    files: {
      type: Array,
      required: true
    }
  }
}
</script>

<template>
  <div class="c-file-list">
    <div class="c-file-list-content">

      <div
        v-for="(file, i) in files"
        :key="file.id"
        class="c-file-list-row"
      >

        <div class="c-file-list-index">
          {{ i + 1 }}
        </div>

        <file-list-item
          :file="file"
          class="c-file-list-button"
        />

      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-file-list-row {
  @include push-pad-bottom;
  @include flex;
  @include flex-center;
}

.c-file-list-index {
  @include flex-fixed;
  @include push-tight-right;
  @include align-right;
  width: 1.5rem;
}

.c-file-list-button {
  @include flex-fluid;
}

</style>
